var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYearsLorry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 0a1 1 0 00-1 1v8.567A.5.5 0 000 10v1.25a.5.5 0 00.5.5h.561l-.404.501a.25.25 0 00.038.352l.194.157a.25.25 0 00.352-.038l.784-.972h.24a2 2 0 103.97 0H7.75v1a.5.5 0 00.5.5h7.917a.5.5 0 00.5-.5v-1h1.348a2 2 0 103.969 0h.766a.5.5 0 00.5-.5V6.59a.5.5 0 00-.03-.174l-.845-2.291-.747-1.815a.5.5 0 00-.463-.31H16.75a.5.5 0 00-.5.5v7h-1.333V1a1 1 0 00-1-1H1.25zm17 2.75a.5.5 0 00-.5.5V5.5a.5.5 0 00.5.5h3.31a.5.5 0 00.475-.656l-.348-1.06-.442-1.206a.5.5 0 00-.47-.328H18.25zM5.25 12a1 1 0 11-2 0 1 1 0 012 0zM20 13a1 1 0 100-2 1 1 0 000 2z",
    fill: "#666"
  })));
}

export default SvgYearsLorry;